import { useEffect, useState } from "react";
import Loader from "react-loader-spinner";
import { Box, Button, Flex, Stack, Img, Text, VStack, Center, Heading, Grid, FormControl, FormLabel, InputGroup, InputRightElement,
    IconButton, AlertDialog, AlertDialogOverlay, AlertDialogBody, HStack, AlertDialogContent, AlertDialogHeader,
    useDisclosure, AlertDialogFooter, useToast } from "@chakra-ui/react";
import { isGmailEmail, toAbsoluteUrl, toastGenerator } from "../../utils/helper";
import { InputControl, SelectControl } from "../../components/Controls";
import { useForm } from "react-hook-form";
import { HiUser } from "react-icons/hi";
import { useAuth } from "../../plugins/CookieAuthPlugin";
import { useAddUserDeleteRequest } from "../../utils/hooks/userDeleteFrom";
import { useGetUserDeleteReasonDropDown } from "../../utils/hooks/dropDown";
export default function DeleteUserForm() {
	const { control, handleSubmit, reset } = useForm();
	const { user, logout } = useAuth();
    const [isLaoding, setisLaoding] = useState(false);
    const { isOpen: isAlertMessageModalOpen, /* onOpen: onAlertMessageModalOpen, */ onClose: onAlertMessageModalClose, } = useDisclosure();
    const toast = useToast();
	useEffect(()=>{
		user && logout();
		// eslint-disable-next-line
	},[]);

    //dropdown
    const userDeleteReasonDropDown = useGetUserDeleteReasonDropDown({
        payload: { page: 1, rowsPerPage: 100 },
    });

    const addUserDeleteRequestMutation = useAddUserDeleteRequest({
        onSuccess(data) {
            setisLaoding(false);
            if(data) {
                if (data.body.status) {
                    toast( toastGenerator({status: data.body.status ? "success" : "warning", message: data.body.message,}));
                    reset({});
                }else{
                    toast( toastGenerator({status: data.body.status ? "success" : "warning", message: data.body.message,}));
                }
            }
        },
        onError() {
            toast(toastGenerator({ status: "error" }));
            setisLaoding(false);
        },
    });

	const onSubmit = (values) => {
        setisLaoding(true)
        const jsonData = {
            username: values.username,
            reasonId: values.reason.value,
            type: isGmailEmail(values.username) ? 2 : 1
        }
        addUserDeleteRequestMutation.mutate(jsonData);
	}

	return (
    <>
        <AlertDialog motionPreset="slideInBottom" isOpen={isAlertMessageModalOpen} isCentered>
        <AlertDialogOverlay />

        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg">Comfirm Message</AlertDialogHeader>
          <AlertDialogBody>
            Are you sure you want to exit this page?
          </AlertDialogBody>
          <AlertDialogFooter>
            <HStack spacing="2">
              <Button onClick={onAlertMessageModalClose}>No</Button>
              <Button>
                Yes
              </Button>
            </HStack>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

		<Center columns={{ md: 2, sm: 1 }} h="100vh" bg="gray.100">
			<VStack bgRepeat="no-repeat" w={{xl: "30vw", lg: "40vw", md: "50vw", sm: "100%"}} h={{xl: "80vh", lg: "80vh", md: "80vh", sm: "100%", base: "100%"}} overflow="hidden" borderRadius="10" bg="white" justify="center">
				<VStack>
					<Img width="20%" src={toAbsoluteUrl("/assets/apsara.png")} alt="Apsara Authorithy Logo" />
					<Grid textAlign="center">
						<Heading mt="10%" textAlign='center' fontSize="150%">Request to delete account</Heading >
						<Box as="h4"  mt="2%"color='brand.100'>Please input username and reason</Box>
					</Grid>
				</VStack>
				<Box h="55%" pt="10%" zIndex="banner" w={{ base: "80%", md: "85%" }} as="form" onSubmit={handleSubmit(onSubmit)}>
					<Stack spacing="4">

						<FormControl id="username">
							<FormLabel color="gray.600" fontWeight="normal">
								Phone Number or Gmail
							</FormLabel>
							<InputGroup>
								<InputRightElement>
									<IconButton color='brand.100' bg='transparent !important' icon={<HiUser/>}/>
								</InputRightElement>
								<InputControl
									name="username"
									control={control}
									placeholder="Enter Phone Number or Gmail"
									isRequired
								/>
							</InputGroup>
						</FormControl>

						<FormControl id="username">
							<FormLabel color="gray.600" fontWeight="normal">
							Reason
							</FormLabel>
							<InputGroup>
								<SelectControl
									name="reason"
									placeholder="Select Reason"
									isClearable
									isRequired
									control={control}
									options={userDeleteReasonDropDown.data}
								/>
							</InputGroup>
						</FormControl>

						<Button type="submit" isLoading={isLaoding} spinner={<Loader type="ThreeDots" color="#fff" height={40} width={40} />} colorScheme="brand" size="md">
							Request
						</Button>

						<Center>
							<VStack mt={{xl: "7%", lg: "10%", md: "10%", sm: "17%", base: "40%"}}>
								<Flex textAlign="center" opacity="0.9" bottom="5" fontSize="small" fontWeight="bold">
									Powered by&nbsp;<Text color="brand.500">UDAYA TECHNOLOGY Co., Ltd.</Text>
									&nbsp;
								</Flex>
							</VStack>
						</Center>
					</Stack>
				</Box>

			</VStack>
		</Center>
    </>
	);
}
